const messages = {
  title: "Turundusnõusolekud",
  required: "Kohustuslik",
  answered: "✓ Vastatud",
  read: "Loetud",
  notRead: "Pole loetud",
  alreadyAnswered: "Juba vastatud",
  requiredQuestionsMustBeAccepted:
    "{count} kohustuslikku küsimust tuleb kinnitada",
  pleaseAnswerQuestions: "Palun vastake järgmistele küsimustele:",
  iAccept: "Nõustun",
  scrollToUnlock: "Avamiseks kerige lõpuni",
  fieldRequired: "See väli on kohustuslik",
  scrollToContinue: "↓ Jätkamiseks kerige lõpuni",
  saving: "Salvestamine...",
  saveConsents: "Salvesta nõusolekud",
  allRequiredAccepted: "✓ Kõik kohustuslikud küsimused kinnitatud",
  requiredConsentsCompleted:
    "{completed}/{total} kohustuslikku nõusolekut täidetud",
  selectConsentToView:
    "Valige loendist nõusolek, et näha selle sisu",
  readAllContentFirst: "Lugege esmalt kogu sisu: {names}",
  acceptAllRequiredIn: "Kinnitage kõik kohustuslikud küsimused: {names}",
  acceptAllBeforeSaving:
    "Enne salvestamist kinnitage kõik kohustuslikud küsimused.",
  failedToSave: "Nõusolekute salvestamine ebaõnnestus. Proovige uuesti.",
  errorSaving:
    "Nõusolekute salvestamisel tekkis viga. Proovige uuesti.",
  failedToLoad: "Nõusolekute laadimine ebaõnnestus. Värskendage lehte.",
  viewPdf: "Kuva PDF",
  requiredConsentTitle: "Kohustuslik nõusolek",
  acceptAndContinue: "Nõustu ja jätka",
};

export default {
  messages,
};
